<template>
    <div :class="type == 'date' ? 'timepicker ' : type == 'week' ? 'timepicker weekd' : 'timepicker duan'">
        <el-date-picker v-model="value" :type="type" ref="timePicker" :readonly="false" :editable="false" :format="format"
            :picker-options="isHistory ? pickerOptions1 : pickerOptions" placeholder="选择周">
        </el-date-picker>
        <span @click="clickTitle">抄表单<i class="el-icon-caret-bottom"></i></span>
    </div>
</template>

<script>
import { dayStart, perMonth } from '../../util/DateUtil'
let cha = 0;
export default {
    props: ['type', 'isHistory'],
    data() {
        return {
            value: new Date(),
            pickerOptions: {
                firstDayOfWeek: 1,
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            pickerOptions1: {
                firstDayOfWeek: 1,
                disabledDate(time) {
                    let now = new Date()
                    let year = now.getFullYear()
                    let month = now.getMonth()
                    let timeChuo = new Date(year, month - cha, 1).getTime()
                    // return time.getTime() > Date.now();
                    return time.getTime() > timeChuo - 1;
                },
            },
        }
    },
    computed: {
        format() {
            let formatPicker = ''
            switch (this.type) {
                case 'month':
                    formatPicker = 'yyyy年MM月'
                    break;
                case 'week':
                    formatPicker = 'yyyy年第WW周'
                    break;
                case 'date':
                    formatPicker = 'yyyy年MM月dd日'
                    break;
            }
            return formatPicker
        },
    },
    watch: {
        value(val) {
            this.$emit('sendTime', dayStart(val).split('T')[0])
            this.$emit('countWeek', val)
        },
        type(val) {
            // console.log(val);
            this.value = new Date()
            this.$emit('sendTime', dayStart(this.value).split('T')[0])
            this.$emit('countWeek', this.value)
        },
    },
    created() {
        if (this.$store.getters.selProjectInfo.settlementDate > new Date().getDate()) {
            cha = 1
        }
    },
    mounted() {
        if (this.isHistory) {
            let time = perMonth(this.value)
            this.value = perMonth(this.value) - cha * 2592000000
            let date = dayStart(time).split('T')[0].split('-')
            this.$emit('sendTime', date[0] + "-" + (Number(date[1]) - cha) + "-" + date[2])
        } else {
            // let date = dayStart(this.value).split('T')[0].split('-')
            // this.value = this.value - cha * 2592000000
            this.$emit('sendTime', dayStart(this.value).split('T')[0])
            // this.$emit('sendTime', date[0] + "-" + (Number(date[1]) - cha) + "-" + date[2])
            this.$emit('countWeek', this.value)
        }
    },
    methods: {
        clickTitle() {
            this.$refs.timePicker.focus()
        },
    }
}
</script>

<style lang="less" scoped>
.timepicker {
    font-size: 24rem;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #333;
    display: flex;
    align-items: center;
    width: 280rem;

    &>span {
        display: inline-block;
        white-space: nowrap;
        cursor: pointer;
    }

    /deep/ .el-input__inner {
        border: none;
        border-bottom: 1px solid #333;
        border-radius: 0;
        padding: 0;
        color: #333;
        font-size: 24rem;
        text-align: center;
        // width: 128rem;
        //180
        cursor: pointer;
    }

    /deep/ .el-date-editor.el-input {
        width: 100%;
    }

    /deep/.el-input__icon {
        display: none;
    }
}

.duan {
    width: 225rem;
}

.weekd {
    width: 250rem;
}
</style>